import Repository from "./Repository";
import store from '../store';
const GetLockerSlots = "GetSlots.php";
const GetClickAndCollectSlots = "GetSlots.php";
const GetDeliverySlots = "GetSlots.php";
const GetCoreSlots = "GetCoreSlots.php";
const GetSlotsMobile = "GetSlotsMobile.php";
const PostAddSlotBooking = "PostAddSlotBooking.php"
const PostConfirmCustomerSlot = "PostTest.php"
const PostConfigureSlots = "PostConfigureSlots.php"
const PostUpdateCoreHours = "PostUpdateCoreHours.php"

export default {	
	getLockerSlots(){
		return Repository.get(`${GetLockerSlots}?slotType=locker&storeId=${store.state.storeId}`);		
	},
	getClickAndCollectSlots(){
		return Repository.get(`${GetClickAndCollectSlots}?slotType=clickandcollect&storeId=${store.state.storeId}`);		
	},
	getDeliverySlots(){
		return Repository.get(`${GetDeliverySlots}?slotType=delivery&storeId=${store.state.storeId}`);		
	},
	getSlots(){
		return Repository.get(`${GetSlotsMobile}`);		
	},
	getCoreSlots(){
		return Repository.get(`${GetCoreSlots}?bid=${store.state.storeId}`);	
	},
	postAddSlotBooking(payload){
		return Repository.post(`${PostAddSlotBooking}`, payload);		
	},
	postConfirmCustomerSlot(payload){
		return Repository.post(`${PostConfirmCustomerSlot}`, payload);		
	},
	postConfigureSlots(payload){
		return Repository.post(`${PostConfigureSlots}`, payload);		
	},
	postUpdateCoreHours(payload){
		return Repository.post(`${PostUpdateCoreHours}`, payload);		
	}
};
